import {Component, Inject} from '@angular/core';
import {Employee, EmployeeBankingInformationAPIModel} from "../../../models/api.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CLEAR_EMPLOYEE_BANKING_INFO, FETCH_EMPLOYEE_BANKING_INFO} from "../../../store/action/employee.action";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/state/app.state";
import {Observable} from "rxjs";
import {EmployeeService} from "../../../services/employee/employee.service";
import {BANKING_INFO_LABEL_MAPPING} from "../../../constants/global-constants";

@Component({
  selector: 'app-employee-details-dialog',
  templateUrl: './employee-details-dialog.component.html',
  styleUrl: './employee-details-dialog.component.scss'
})
export class EmployeeDetailsDialogComponent {
  details: Employee
  bankingInfo$: Observable<EmployeeBankingInformationAPIModel[]>

  constructor(
    private appState: Store<AppState>,
    private employeeService: EmployeeService,
    public dialogRef: MatDialogRef<EmployeeDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.details = data
    this.loadBankingInformation()
    this.bankingInfo$ = this.employeeService.getEmployeeBankingInfoFromStore();
  }

  loadBankingInformation() {
    this.appState.dispatch(FETCH_EMPLOYEE_BANKING_INFO({ employeeId: this.details.id }))
  }

  onCloseClick(): void {
    this.appState.dispatch(CLEAR_EMPLOYEE_BANKING_INFO())
    this.dialogRef.close()
  }

  protected readonly BANKING_INFO_LABEL_MAPPING = BANKING_INFO_LABEL_MAPPING;
}
